import { useState } from '@hookstate/core';

import { AssetStatus } from './Components/AssetStatus/AssetStatus';
import { CustomFields } from './Components/CustomFields/CustomFields';
import { DefaultFields } from './Components/DefaultFields/DefaultFields';

import {
  Container,
  Title,
  Line,
  Divider,
  Back,
  Indicator,
  Item,
  Label,
  LabelText,
  Tabs,
  TabsContainer,
  Body,
} from './FieldManagement.styles';

const FieldManagement = () => {
  const page = useState<'custom_fields' | 'asset_status' | 'default_fields'>(
    'custom_fields',
  );

  return (
    <Container>
      <Line>
        <Title>Fields Management</Title>
      </Line>
      <Divider height="24px" />

      <TabsContainer>
        <Tabs>
          <Item
            onClick={() => {
              page.set('custom_fields');
            }}
          >
            <Label>
              <LabelText isActive={page.get() === 'custom_fields'}>
                Custom Fields
              </LabelText>
            </Label>

            <Indicator isActive={page.get() === 'custom_fields'} />
          </Item>
          <Item
            onClick={() => {
              page.set('asset_status');
            }}
          >
            <Label>
              <LabelText isActive={page.get() === 'asset_status'}>
                Asset Status
              </LabelText>
            </Label>
            <Indicator isActive={page.get() === 'asset_status'} />
          </Item>
          <Item
            onClick={() => {
              page.set('default_fields');
            }}
          >
            <Label>
              <LabelText isActive={page.get() === 'default_fields'}>
                Default Fields
              </LabelText>
            </Label>
            <Indicator isActive={page.get() === 'default_fields'} />
          </Item>
        </Tabs>
        <Back />
      </TabsContainer>

      <Body show={page.get() === 'custom_fields'}>
        <CustomFields />
      </Body>

      <Body show={page.get() === 'asset_status'}>
        <AssetStatus />
      </Body>

      <Body show={page.get() === 'default_fields'}>
        <DefaultFields />
      </Body>
    </Container>
  );
};

export { FieldManagement };
